import Tone from 'tone';

const DELAY = 0;
let id=0;

class SessionEvent {

    constructor() {
        this.canceled = false;
        this.id = id++;
    }

    setValue(v) {}

    get value() {
        return this.getValue();
    }

    set value(v) {
        this.setValue(v);
    }

    cancel() {
        this.canceled = true;
    }

    isDeterministic() {
        return false;
    }

    isSkippable() {
        return true;
    }

    isPrunable() {
        return false;
    }

    setTime(time, step) {
        this.step = step;
        // time in millisconds after step occurs
        this.time = time;
    }

    scheduleEvent(time, sequencerEngine, nextEvent) {
        time = time + this.time;
        setTimeout(() => {
            if (!this.canceled) {
                try {
                    this.executeEvent(sequencerEngine, nextEvent);
                } catch (err) {
                    console.log('got an error executing event = ');
                    console.log(this);
                    console.log(err);
                }
            } 
        }, time - DELAY);
    }

    getValue() {
    }

    // gets overrided by sub-classes
    executeEvent(sequencerEngine) {
    }

    getType() {
        return undefined;
    }

    getJson() {
        return {
            type: this.getType(),
            time: this.time,
            step: this.step
        };
    }

    fromJson(json) {
        this.time = json.time;
        this.step = json.step;
        return this;
    }

    isEquivalent() {
        return false;
    }

    restart() {
    }

    getCopy() {
    }

    loadSubSequence(json, sequencerEngine) {
        if (json.subSequence !== undefined) {
            this.subSequence = sequencerEngine.getSubSequence(json.subSequence);
        } else {
            this.subSequence = sequencerEngine.currentSubSequence;
        }
    }
}

export default SessionEvent;
